import { WorkingWithUsSectionStyles } from '../section.style';
import { HelpTitle, PaddedContent, ParagraphText } from './what-we-do.style';
import { CheckMarkList } from '@exploration/shared-components';
import { useForceBreakpoint } from '@exploration/ui-utils';
import { MDSText } from '@midwest/web/base';
import { MDSLink } from '@midwest/web/link';

const { Container, Content, ContentText } = WorkingWithUsSectionStyles;

export type CheckMarkListProps = string;

export interface WhatWeDoSectionProps {
  headline: string;
  subHeadline?: string;
  callToAction: Array<{
    headline?: string;
    link: string;
    subHeadline?: string;
    text: string;
    ariaId?: string;
    buttonId?: string;
    icon?: string;
  }>;
  content: CheckMarkListProps[];
  className?: string;
}

const WhatWeDoSection = ({
  headline,
  callToAction,
  subHeadline,
  content,
}: WhatWeDoSectionProps) => {
  PaddedContent.defaultProps = {
    forceMobileBreakpoint: useForceBreakpoint() === 'mobile',
  };
  ContentText.defaultProps = {
    forceMobileBreakpoint: useForceBreakpoint() === 'mobile',
  };
  Container.defaultProps = {
    forceMobileBreakpoint: useForceBreakpoint() === 'mobile',
  };

  return (
    <Container>
      <Content>
        <ContentText>
          <MDSText.TitleMd as="h2">{headline}</MDSText.TitleMd>
          {!!subHeadline && <ParagraphText>{subHeadline}</ParagraphText>}
          <MDSLink type="navigational" href={callToAction[0]?.link}>
            {callToAction[0]?.text}
          </MDSLink>
        </ContentText>
      </Content>
      <PaddedContent>
        <HelpTitle>{'We can help you with'}</HelpTitle>
        <CheckMarkList items={content} />
      </PaddedContent>
    </Container>
  );
};

export default WhatWeDoSection;
